var SENTRY_RELEASE;SENTRY_RELEASE={name: "new-public-psi", version: "1.105.0"};